export const environment = {
    production: true,
    urlAPI: 'https://prodfor-back-prd-b2g0brb3cfcwcbdt.eastus2-01.azurewebsites.net/api',
    azureStorageUrl: 'https://storageprodforprd.blob.core.windows.net/arquivos-migrados',
    avatarPadrao: './assets/img/avatar.jpg',
    logoEmpresaPadrao: './assets/img/logo.jpg',
    apiReceitaFederalConsultaCNPJ: 'https://www.receitaws.com.br/v1/cnpj/',
    apiConsultaCEP: 'https://viacep.com.br/ws/_CEP_/json/',
    firebaseConfig: {
        apiKey: 'AIzaSyDRwTTgUSfaoyuabnovZHISwZ0Pk96MCJ4',
        authDomain: 'prodfor-sip-2.firebaseapp.com',
        databaseURL: 'https://prodfor-sip-2.firebaseio.com',
        projectId: 'prodfor-sip-2',
        storageBucket: 'prodfor-sip-2.appspot.com',
        messagingSenderId: '509744014016'
    }
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts